import { useQuery } from 'react-query';
import * as psiFlowService from '@/services/psiFlowService';
import type { FlowType } from '@/types/psiFlow';

// ============================================================================
// Query Keys
// ============================================================================

export const PSI_FLOW_QUERY_KEYS = {
  all: ['psiFlows'] as const,
  lists: () => [...PSI_FLOW_QUERY_KEYS.all, 'list'] as const,
  list: (filter?: { type?: FlowType; status?: string }) =>
    [...PSI_FLOW_QUERY_KEYS.lists(), filter] as const,
  details: () => [...PSI_FLOW_QUERY_KEYS.all, 'detail'] as const,
  detail: (flowId: string) => [...PSI_FLOW_QUERY_KEYS.details(), flowId] as const,
  reminders: () => [...PSI_FLOW_QUERY_KEYS.all, 'reminders'] as const,
  stats: () => [...PSI_FLOW_QUERY_KEYS.all, 'stats'] as const,
};

// ============================================================================
// Flow Hooks
// ============================================================================

export function usePSIFlows(filter?: { type?: FlowType; status?: string }) {
  return useQuery(
    PSI_FLOW_QUERY_KEYS.list(filter),
    () => psiFlowService.listFlows(filter),
    {
      keepPreviousData: true,
      staleTime: 30000,
      cacheTime: 300000,
    }
  );
}

export function usePSIFlow(flowId: string | undefined) {
  return useQuery(
    PSI_FLOW_QUERY_KEYS.detail(flowId!),
    () => psiFlowService.getFlow(flowId!),
    {
      enabled: !!flowId,
      staleTime: 30000,
    }
  );
}

export function usePSIFlowReminders() {
  return useQuery(
    PSI_FLOW_QUERY_KEYS.reminders(),
    () => psiFlowService.getFlowReminders(),
    {
      staleTime: 60000,
      cacheTime: 300000,
    }
  );
}

export function usePSIFlowStats() {
  return useQuery(
    PSI_FLOW_QUERY_KEYS.stats(),
    () => psiFlowService.getFlowStats(),
    {
      staleTime: 60000,
      cacheTime: 300000,
    }
  );
}
